/**
 * Configuração da API Interna
 *
 * Esta configuração é usada pela instância axios-internal para comunicação
 * com a API interna do GVoz.
 */
export const INTERNAL_API_CONFIG = {
  // Base URL da API Interna - usa proxy do dev server para evitar CORS
  baseURL: '/internal/v1',
  serviceKey: process.env.VUE_APP_SERVICE_KEY,
  timeout: 30000,
  userIdStorageKey: 'userId',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
}

/**
 * Permissões necessárias para o módulo de agendamentos
 *
 * Estas permissões são validadas no backend para o usuário
 * informado no header X-User-Id
 */
export const AGENDAMENTOS_PERMISSIONS = {
  ACCESS: 'access-agendamentos', // Obrigatória para todas as rotas
  VIEW: 'view-agendamentos', // Para consultas
  CREATE: 'create-agendamentos', // Para criação
  UPDATE: 'update-agendamentos', // Para atualização
}

/**
 * Códigos de erro específicos da API Interna
 */
export const INTERNAL_API_ERRORS = {
  INVALID_SERVICE_KEY: 'INVALID_SERVICE_KEY',
  MISSING_USER_ID: 'MISSING_USER_ID',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  INSUFFICIENT_PERMISSIONS: 'INSUFFICIENT_PERMISSIONS',
}

export default INTERNAL_API_CONFIG
